/**
 * メッセージコードの列挙型
 */
export const MessageCodeEnum = {
  /** 60001_位置情報サービスが利用できません。 */
  LOCATION_SERVICE_NOT_AVAILABLE: '60001',
  /** 60002_支社が選択されていません。 */
  OFFICE_NOT_SELECTED: '60002',
  /** 60003_駅が選択されていません。 */
  STATION_NOT_SELECTED: '60003',
  /** 60004_トラックまたはヘッドが選択されていません。 */
  TRUCK_OR_HEAD_NOT_SELECTED: '60004',
  /** 60005_シャーシが選択されていません。 */
  CHASSIS_NOT_SELECTED: '60005',
  /** 60006_トラックコンテナ積載個数が選択されていません。 */
  TRUCK_CONTAINER_CNT_NOT_SELECTED: '60006',
  /** 60007_車番が選択されていません。 */
  TRUCK_NUMBER_NOT_SELECTED: '60007',
  /** 60008_伝票番号を入力してください。 */
  DOCUMENT_NO_REQUIRED: '60008',
  /** 60009_伝票番号は9桁または13桁または20桁で入力してください。 */
  DOCUMENT_NO_LENGTH: '60009',
  /** 60010_既に読込済みの伝票番号です。 */
  DOCUMENT_ALREADY_READ: '60010',
  /** 60011_作業の内容が変更されています。画面と伝票を確認してください。 */
  WORK_CHANGED: '60011',
  /** 60012_ウイング車代行の伝票は読み込みできません。 */
  WING_DELEGATE_DOCUMENT_NOT_AVAILABLE: '60012',
  /** 60013_作業を開始する伝票が選択されていません。 */
  START_WORK_NOT_SELECTED: '60013',
  /** 60014_アラートメッセージが確認済みとなっていない作業があります。 */
  ALERT_NOT_CHECKED_WORK_EXISTS: '60014',
  /** 60015_開始する代行利用者を選択してください。 */
  STARTING_DELEGATE_USER_NOT_SELECTED: '60015',
  /** 60016_同時に１００件以上報告することはできません。報告件数を９９件以下にしてください。 */
  TOO_MUCH_WORK_SELECTED: '60016',
  /** 60017_トラックを選択してください。 */
  TRUCK_NOT_SELECTED: '60017',
  /** 60018_作業の報告を行ってから作業完了ボタンを押してください。 */
  REPORT_WORK_REQUIRED: '60018',
  /** 60019_報告を行っていない作業があります。よろしいですか？ */
  NOT_REPORTED_WORK_EXISTS: '60019',
  /** 60020_同じコンテナにまだ報告していない作業があります。確認してください。 */
  NOT_REPORTED_WORK_IN_SAME_CONTAINER_EXISTS: '60020',
  /** 60021_報告するコンテナが不一致です。確認してください。 */
  UNMATCHED_CONTAINER_WORK_EXISTS: '60021',
  /** 60022_同じ原票番号の作業を異なるコンテナ番号で報告できません。 */
  UNMATCHED_CONTAINER_NUMBER_IN_ORIGINAL_DOCUMENT: '60022',
  /** 60023_同じ原票番号の作業を異なるコンテナ所在で報告できません。 */
  UNMATCHED_CONTAINER_PLACE_IN_ORIGINAL_DOCUMENT: '60023',
  /** 60024_同じ原票番号の作業を異なる封印環番号で報告できません。 */
  UNMATCHED_SEAL_RING_NO_IN_ORIGINAL_DOCUMENT: '60024',
  /** 60025_アラートメッセージが確認済みとなっていません。 */
  ALERT_NOT_CHECKED: '60025',
  /** 60026_代行利用者が選択されていません。 */
  DELEGATE_USER_NOT_SELECTED: '60026',
  /** 60027_同じコンテナ番号の作業を異なるコンテナ所在で報告できません。 */
  UNMATCHED_CONTAINER_PLACE_IN_SAME_CONTAINER: '60027',
  /** 60028_コンテナ番号を入力してください。 */
  CONTAINER_NO_REQUIRED: '60028',
  /** 60029_伝票の読込が完了しました。 */
  FINISH_LOAD_DOCUMENT: '60029',
  /** 60030_この伝票を画面から削除しますか？ */
  CONFIRM_DELETE_DOCUMENT: '60030',
  /** 60031_作業を完了する伝票が選択されていません。 */
  END_WORK_NOT_SELECTED: '60031',
  /** 60032_作業報告を取り消しますか？ */
  CONFIRM_CANCEL_WORK: '60032',
  /** 60033_完了する代行利用者を選択してください。 */
  ENDING_DELEGATE_USER_NOT_SELECTED: '60033',
  /** 60034_ライトが使用できません。 */
  TORCH_NOT_AVAILABLE: '60034',
  /** 60035_通信に失敗しました。\n時間をおいて再度お試しください。 */
  NETWORK_ERROR: '60035',
  /** 60036_作業駅が設定されていません。 */
  WORKING_STATION_IS_NOT_SET: '60036',
  /** 60037_日付が選択されていません。 */
  DATE_NOT_SELECTED: '60037',
  /** 60038_カメラが使用できません。 */
  CAMERA_NOT_AVAILABLE: '60038',
  /** 60039_このQRコードは無効です。 */
  INVALID_QR: '60039',
  /** 60040_最寄り駅が見つかりませんでした。 */
  NEAREST_STATION_NOT_FOUND: '60040',
  /** 60041_ログアウトしますか？ */
  CONFIRM_LOGOUT: '60041',
  /** 60042_入力した伝票番号に誤りがあります。 */
  DOCUMENT_NO_INVALID: '60042',
  /** 60043_伝票番号は13桁または20桁で入力してください。 */
  DOCUMENT_NO_LENGTH_FOR_STATION_DELAY: '60043',
  /** 60044_封印環番号は半角で入力してください。 */
  SEAL_RING_NO_HALF_WIDTH_ONLY: '60044',
  /** 60045_封印環番号に入力できない記号が含まれています。 */
  SEAL_RING_NO_INVALID_CHARACTER: '60045',
  /** 60046_一覧をタップすることで、見込情報を表示できます。 */
  TRAIN_DELAY_HELP_MESSAGE: '60046',
  /** 60047_お使いのQRコードはまもなくご利用いただけなくなります。大変お手数ですが、駅フロントの社員へお声がけいただき、新しいQRコードの発行をご依頼ください。 */
  IS_QR_CODE_DEPRECATED: '60047',
  /** 60048_代理ログインを終了しますか？ */
  CONFIRM_PROXY_LOGOUT: '60048',
  /** 60049_現在のパスワードと新しいパスワードは異なる値を入力してください。 */
  PASSWORD_MISMATCH: '60049',
  /** 60050_新しいパスワードは8文字以上16文字以下かつ、英大文字、英小文字、数字、記号をすべて含めてください。 */
  PASSWORD_POLICY_VIOLATION: '60050',
  /** 60051_新しいパスワードと確認用のパスワードが一致しません。 */
  PASSWORD_CONFIRMATION_MISMATCH: '60051',
  /** 60052_無効なアカウント区分が選択されました。 */
  INVALID_ACCOUNT_TYPE_SELECTED: '60052',
  /** 60053_コンテナ番号が重複しています。 */
  DUPLICATE_CONTAINER_NUMBER: '60053',
  /** 60054_$1はカタカナで入力してください。 */
  KANA_ONLY: '60054',
  /** 60055_$1は半角数字で入力してください。 */
  NUMERIC_ONLY: '60055',
  /** 60056_$1は半角英数記号で入力してください。 */
  HALF_WIDTH_ALPHANUMERIC_SYMBOLS_ONLY: '60056',
  /** 60057_所属情報を1件以上設定してください。 */
  AFFILIATION_REQUIRED: '60057',
  /** 60058_$1は半角英数字で入力してください。 */
  HALF_WIDTH_ALPHANUMERIC_ONLY: '60058',
  /** 60059_申請を行いました。登録完了するまでしばらくお待ちください。 */
  APPLICATION_SUBMITTED: '60059',
  /** 60060_選択した所属情報は既に設定済みです。 */
  AFFILIATION_ALREADY_EXISTS: '60060',
  /** 60061_申請を却下しますか？ */
  CONFIRM_REJECTION: '60061',
  /** 60062_申請を却下しました。 */
  REJECTION_COMPLETED: '60062',
  /** 60063_有効な利用者を設定してください。 */
  VALID_USER_COMPANY_REQUIRED: '60063',
  /** 60064_有効な集配人を設定してください。 */
  VALID_DELIVERY_COMPANY_REQUIRED: '60064',
  /** 60065_承認が完了しました。 */
  APPROVAL_COMPLETED: '60065',
  /** 60066_アカウントを削除しますか？ */
  CONFIRM_DELETE_ACCOUNT: '60066',
  /** 60067_アカウントを削除しました。 */
  DELETE_ACCOUNT_COMPLETED: '60067',
  /** 60068_パスワードを初期化しますか？ */
  CONFIRM_RESET_PASSWORD: '60068',
  /** 60069_パスワードを初期化しました。 */
  RESET_PASSWORD_COMPLETED: '60069',
  /** 60070_編集内容を保存しました。 */
  FINISH_SAVE: '60070',
  /** 60071_ユーザ情報変更申請を取り消しますか？ */
  CONFIRM_CANCEL_CHANGE_APPLICATION: '60071',
  /** 60072_ユーザ情報変更申請を取り消しました。 */
  CANCEL_CHANGE_APPLICATION_COMPLETED: '60072',
  /** 60073_ユーザ情報変更申請の取消に失敗しました。お手数ですが再度やり直してください。 */
  CANCEL_CHANGE_APPLICATION_FAILED: '60073',
  /** 60074_新しいQRコードを発行しますか？発行すると、以前に発行済みのQRコードは無効化され、使用できなくなります。 */
  CONFIRM_ISSUE_NEW_QR_CODE: '60074',
  /** 60075_すでに申請中のため新しい申請は行えません。 */
  APPLICATION_ALREADY_IN_PROGRESS: '60075',
  /** 60076_所属情報$1: 有効な利用者を設定してください。 */
  VALID_USER_COMPANY_REQUIRED_WITH_FIELD: '60076',
  /** 60077_所属情報$1: 有効な集配人を設定してください。 */
  VALID_DELIVERY_COMPANY_REQUIRED_WITH_FIELD: '60077',
  /** 60078_権限を変更しました。 */
  CHANGE_ROLE_COMPLETED: '60078',
  /** 60079_ロックを解除しますか？ */
  CONFIRM_UNLOCK_ACCOUNT: '60079',
  /** 60080_ロックを解除しました。 */
  UNLOCK_ACCOUNT_COMPLETED: '60080',
  /** 60081_【注意】緊締装置の「解錠」忘れにご注意！ */
  INTER_BOX_CONNECTOR_WARNING: '60081',
  /** 60082_$1は全角文字で入力してください。 */
  FULL_WIDTH_CHARACTERS_ONLY: '60082',
  /** 60083_パスワードを変更しました。 */
  PASSWORD_CHANGED: '60083',
  /** 60084_$1に記号は使用できません。 */
  SYMBOL_NOT_ALLOWED: '60084',
  /** 60085_アカウントをロックしますか？ */
  CONFIRM_LOCK_ACCOUNT: '60085',
  /** 60086_アカウントをロックしました。 */
  LOCK_ACCOUNT_COMPLETED: '60086',
  /** 60087_【注意】緊締装置の「施錠」忘れにご注意！ */
  INTER_BOX_CONNECTOR_LOCK_WARNING: '60087',
  /** 60088_【注意】緊締装置の「施錠・解錠」忘れにご注意！ */
  INTER_BOX_CONNECTOR_LOCK_UNLOCK_WARNING: '60088',
  /** 60089_$1はメールアドレスの形式で入力してください。 */
  EMAIL_FORMAT_ONLY: '60089',
  /** 60090_$1は$2桁で入力してください。 */
  SPECIFIED_LENGTH: '60090',
  /** 60091_システムエラーが発生しました。お手数ですが、再度お試しください。問題が解消しない場合は、サポートまでお問い合わせください。 */
  SYSTEM_ERROR: '60091',
  /** 60092_この申請は既に操作されています。承認一覧画面に戻ります。 */
  APPLICATION_ALREADY_PROCESSED: '60092',
  /** 60093_位置情報が取得できません。 */
  LOCATION_UNAVAILABLE_POOR_SIGNAL: '60093',
  /** 60094_位置情報が取得できません。GPSをONにしてください。 */
  LOCATION_UNAVAILABLE_GPS_OFF: '60094',
  /** 60095_安全のため、移動中は操作できません。 */
  SPEED_EXCEEDED: '60095',
  /** 61001_$1は入力必須です。 */
  REQUIRED_FIELD: '61001',
  /** 69999_予期せぬエラーが発生しました。 */
  UNKNOWN_ERROR: '69999',
} as const;

/**
 * メッセージコード
 */
export type MessageCode = typeof MessageCodeEnum[keyof typeof MessageCodeEnum];
